import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountStyles";
import { Field, reduxForm } from "redux-form";
import Header from "../components/Header";
import Loading from "../components/Loading";
import PageTitle from "../components/PageTitle";
import Stepper from "../components/Stepper";
import StepperIntro from "../components/StepperIntro";

import { setupActions, userActions } from "../_actions";
import { connect } from "react-redux";

import NumberStepper from "../components/NumberStepper";
import RadioInput from "../components/RadioInput";
import PopupWrapper from "../components/PopupWrapper";

let stage,
  success = false;

class Setup extends Component {
  constructor(props) {
    super(props);
    let user = JSON.parse(localStorage.getItem("user"));

    if (user.user_id) {
      stage = 1;
    } else if (user.dependant_user_id) {
      stage = 2;
    }
    this.props.dispatch(
      setupActions.getDetail(
        stage === 1 ? user.user_id : user.dependant_user_id
      )
    );
    this.props.dispatch(userActions.setSetup());
  }

  submit = values => {
    let user = JSON.parse(localStorage.getItem("user"));

    this.props.dispatch(
      setupActions.submitSetup(
        stage === 1 ? user.user_id : user.dependant_user_id,
        values
      )
    );
    if (stage === 1 && user.dependant_user_id) {
      stage = 2;
      this.props.dispatch(setupActions.getDetail(user.dependant_user_id));
    } else {
      success = true;
    }
  };

  render() {
    const {
      handleSubmit,
      initialValues,
      setup: { fetchingDetail, step }
    } = this.props;

    let user = JSON.parse(localStorage.getItem("user"));

    return (
      <div>
        <Header
          title={
            step === 0
              ? "Welcome"
              : stage === 1
              ? "Setting up My Home"
              : "Setting up Parent's Home"
          }
          backTitle={"Close"}
          isSetup={true}
          step={step}
          stage={stage}
          backHref={"/"}
        />
        {step === 0 && (
          <PageTitle
            title={"Setup"}
            subTitle={
              "In order to customise our alerts and other features in the App to your specific household, we need to collect some additional information about the number and type of appliances within your home. To help us with this, please complete the following questions."
            }
          />
        )}
        <div className={css(styles.mainContainer)}>
          <PopupWrapper />
          <form onSubmit={handleSubmit(this.submit)}>
            {fetchingDetail && <Loading />}
            {!fetchingDetail && step === 0 && (
              <div>
                <div
                  className={css(styles.completeBox, success && styles.success)}
                >
                  {success ? "Setup Complete" : "2 Minutes to Complete"}
                </div>
                {user.user_id &&
                  user.dependant_user_id &&
                  stage &&
                  !success && <StepperIntro activeStep={stage} />}
                {!success && (
                  <button
                    onClick={() =>
                      this.props.dispatch(setupActions.incrementStep())
                    }
                    className={css(styles.buttonGreen)}
                  >{`Start${
                    !stage ? "" : stage === 1 ? " My Home" : " Parent's Home"
                  } Setup`}</button>
                )}
                {!success && (
                  <p className={css(styles.changeAnswers)}>
                    You can change any answers later in your account
                  </p>
                )}
              </div>
            )}
            {!fetchingDetail && step !== 0 && <Stepper activeStep={step} />}
            {!fetchingDetail && step === 1 && (
              <div>
                <h3 className={css(styles.subtitle)}>
                  How many people live in your home normally?
                </h3>

                <label htmlFor="under10" className={css(styles.label)}>
                  Children aged under 10
                </label>
                <Field
                  name="under10"
                  className={css(styles.input)}
                  component={NumberStepper}
                />
                <label htmlFor="range10_17" className={css(styles.label)}>
                  Young people aged 10-17
                </label>
                <Field
                  name="range10_17"
                  className={css(styles.input)}
                  component={NumberStepper}
                />
                <label htmlFor="range18_64" className={css(styles.label)}>
                  Adults aged 18-64
                </label>
                <Field
                  name="range18_64"
                  className={css(styles.input)}
                  component={NumberStepper}
                />
                <label htmlFor="range65_74" className={css(styles.label)}>
                  Adults aged 65-74
                </label>
                <Field
                  name="range65_74"
                  className={css(styles.input)}
                  component={NumberStepper}
                />
                <label htmlFor="over74" className={css(styles.label)}>
                  Adults aged 75+
                </label>
                <Field
                  name="over74"
                  className={css(styles.input)}
                  component={NumberStepper}
                />
                <div className={css(styles.flexLine)}>
                  <button
                    onClick={() =>
                      this.props.dispatch(setupActions.decrementStep())
                    }
                    className={css(styles.buttonWhite)}
                  >
                    Go Back
                  </button>
                  <button
                    onClick={() =>
                      this.props.dispatch(setupActions.incrementStep())
                    }
                    className={css(styles.buttonGreen)}
                  >
                    Next Question
                  </button>
                </div>
              </div>
            )}
            {!fetchingDetail && step === 2 && (
              <div>
                <h3 className={css(styles.subtitle)}>
                  How many people 18 or over have these employment statuses?
                </h3>
                <label htmlFor="full_time" className={css(styles.label)}>
                  Full-time employment
                </label>
                <Field
                  name="full_time"
                  className={css(styles.input)}
                  component={NumberStepper}
                />
                <label htmlFor="part_time" className={css(styles.label)}>
                  Part-time employment
                </label>
                <Field
                  name="part_time"
                  className={css(styles.input)}
                  component={NumberStepper}
                />
                <label htmlFor="unemployed" className={css(styles.label)}>
                  Unemployed
                </label>
                <Field
                  name="unemployed"
                  className={css(styles.input)}
                  component={NumberStepper}
                />
                <label htmlFor="pensioner" className={css(styles.label)}>
                  Pensioner
                </label>
                <Field
                  name="pensioner"
                  className={css(styles.input)}
                  component={NumberStepper}
                />
                <h3 className={css(styles.subtitle)}>
                  For those in the household, which type of travel do they have?
                </h3>
                <label htmlFor="commuting" className={css(styles.label)}>
                  Commuting
                </label>
                <Field
                  name="commuting"
                  className={css(styles.input)}
                  component={NumberStepper}
                />
                <label htmlFor="stay_at_home" className={css(styles.label)}>
                  None, stay at home
                </label>
                <Field
                  name="stay_at_home"
                  className={css(styles.input)}
                  component={NumberStepper}
                />
                <div className={css(styles.flexLine)}>
                  <button
                    onClick={() =>
                      this.props.dispatch(setupActions.decrementStep())
                    }
                    className={css(styles.buttonWhite)}
                  >
                    Go Back
                  </button>
                  <button
                    onClick={() =>
                      this.props.dispatch(setupActions.incrementStep())
                    }
                    className={css(styles.buttonGreen)}
                  >
                    Next Question
                  </button>
                </div>
              </div>
            )}
            {!fetchingDetail && step === 3 && (
              <div>
                <h3 className={css(styles.subtitle)}>
                  How many of these appliances do you have in your home?
                </h3>
                {initialValues && initialValues.appliances && Object.entries(initialValues.appliances).map(([applianceName, appliance]) => (
                    <div key={applianceName} className={css(styles.flexField)}>
                      <label htmlFor={applianceName} className={css(styles.flexLabel)}>
                        {appliance.name}
                      </label>
                      <Field
                          name={applianceName}
                          className={css(styles.input)}
                          component={NumberStepper}
                      />
                    </div>
                ))}
                <div className={css(styles.flexLine)}>
                  <button
                    onClick={() =>
                      this.props.dispatch(setupActions.decrementStep())
                    }
                    className={css(styles.buttonWhite)}
                  >
                    Go Back
                  </button>
                  <button
                    onClick={() =>
                      this.props.dispatch(setupActions.incrementStep())
                    }
                    className={css(styles.buttonGreen)}
                  >
                    Next Question
                  </button>
                </div>
              </div>
            )}
            {!fetchingDetail && step === 4 && (
              <div>
                <h3 className={css(styles.subtitle)}>
                  What kind of home do you live in?
                </h3>
                <Field
                  name="property_type"
                  className={css(styles.input)}
                  component={RadioInput}
                />
                <div className={css(styles.flexLine)}>
                  <button
                    onClick={() =>
                      this.props.dispatch(setupActions.decrementStep())
                    }
                    className={css(styles.buttonWhite)}
                  >
                    Go Back
                  </button>
                  <button type="submit" className={css(styles.buttonGreen)}>
                    Finish Setup
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetchingDetail } = state.setup;

  const applianceValues = {};

  if(state.setup.detail && state.setup.detail.appliances) {
    Object.entries(state.setup.detail.appliances).forEach(([applianceName, appliance]) => {
      applianceValues[applianceName] = appliance.number;
    });
  }

  const initialValues = {
    appliances: {},
    ...applianceValues,
    under10:
      state.setup.detail.age_groups && state.setup.detail.age_groups.under10,
    range10_17:
      state.setup.detail.age_groups && state.setup.detail.age_groups.range10_17,
    range18_64:
      state.setup.detail.age_groups && state.setup.detail.age_groups.range18_64,
    range65_74:
      state.setup.detail.age_groups && state.setup.detail.age_groups.range65_74,
    over74:
      state.setup.detail.age_groups && state.setup.detail.age_groups.over74,
    full_time:
      state.setup.detail.employment_statuses &&
      state.setup.detail.employment_statuses.full_time,
    part_time:
      state.setup.detail.employment_statuses &&
      state.setup.detail.employment_statuses.part_time,
    unemployed:
      state.setup.detail.employment_statuses &&
      state.setup.detail.employment_statuses.unemployed,
    pensioner:
      state.setup.detail.employment_statuses &&
      state.setup.detail.employment_statuses.pensioner,
    commuting: state.setup.detail.travel && state.setup.detail.travel.commuting,
    stay_at_home:
      state.setup.detail.travel && state.setup.detail.travel.stay_at_home,
    property_type: state.setup.detail.property_type
  };

  initialValues.appliances = state.setup.detail.appliances;

  return {
    fetchingDetail,
    initialValues,
    ...state
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "setup", // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    enableReinitialize: true
  })(Setup)
);
